import React from 'react';
import { isBrowser } from './dom.es.js';

const useEnhancedEffect = isBrowser ? React.useLayoutEffect : React.useEffect;

export { useEnhancedEffect };
//# sourceMappingURL=useEnhancedEffect.es.js.map
